import React, { useEffect, useState } from "react";
import QueryList from "./QueryList";
import {
  listQueryTypeDetailsService,
  queryListService,
} from "../../services/queryServices";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";

const RaiseQuery = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  const [searchedRows, setSearchedRows] = useState([]);
  const [queryTypeList, setQueryTypeList] = useState(null);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState(0);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const initialLoad = async () => {
    try {
      setLoading(true);
      await getQuerryTypeList();
      await getQueryList(0, 10);
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Fetch List Query Details"
      );
    } finally {
      setLoading(false);
    }
  };

  const getQuerryTypeList = async () => {
    try {
      setLoading(true);

      const querryTypeList = await listQueryTypeDetailsService(baseUrl);

      if (querryTypeList?.messageCode === 6) {
        setQueryTypeList(querryTypeList.queryTypeParam);
      } else {
        showNotification(
          "Info",
          querryTypeList?.message ?? "Failed To Fetch Query Type List"
        );
      }
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getQueryList = async (pageno, pageSize, isUpdate = false) => {
    try {
      setLoading(true);
      const queryTypeListResponse = await queryListService(baseUrl, {
        pageNumber: pageno,
        pageSize: pageSize,
      });
      if (queryTypeListResponse?.messageCode === 6) {
        if (isUpdate) {
          setSearchedRows([
            ...searchedRows,
            ...queryTypeListResponse?.queryPage?.content,
          ]);
        } else {
          setSearchedRows(queryTypeListResponse?.queryPage?.content);

          setTotalNoOfRecords(queryTypeListResponse?.queryPage?.totalElements);
        }
      } else {
        showNotification(
          "Error",
          queryTypeListResponse?.message ?? "Failed To Fetch List Query Details"
        );
      }
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <QueryList
        setSearchedRows={setSearchedRows}
        searchedRows={searchedRows}
        queryTypeList={queryTypeList}
        totalNoOfRecords={totalNoOfRecords}
        getQueryList={getQueryList}
      />
    </>
  );
};
export default RaiseQuery;
